import { reducerWithInitialState } from '../../node_modules/typescript-fsa-reducers/dist'
import Market from '../model/Market'
import { Success, Failure } from '../../node_modules/typescript-fsa'
import { LoadMarketList } from '../pages/ReportGroupSelection/actions/LoadMarketList'
import * as _ from 'lodash'

export type MarketState = {
  markets?: _.Dictionary<Market>
  marketsLoading: boolean
  errorMessage: string
}
export const marketInitialState = {
  marketsLoading: true,
  errorMessage: ''
}
export const marketReducer = reducerWithInitialState<MarketState>(marketInitialState)
  .case(LoadMarketList.started, (state: MarketState, dummy: null) => ({
    ...state,
    marketsLoading: true
  }))
  .case(LoadMarketList.done, (state: MarketState, payload: Success<null, Market[]>) => ({
    ...state,
    markets: _.keyBy(payload.result, 'key'),
    marketsLoading: false
  }))
  .case(LoadMarketList.failed, (state: MarketState, code: Failure<null, string>) => ({
    ...state,
    errorMessage: `Error loading market list: ${code.error}`
  }))
